export function setOfficeId(newId) {
  localStorage.setItem("officeId", newId);
}
export function getOfficeId() {
  return localStorage.getItem("officeId");
}
